import { render, staticRenderFns } from "./ContractedWorks.vue?vue&type=template&id=19f16e1c&"
import script from "./ContractedWorks.vue?vue&type=script&lang=js&"
export * from "./ContractedWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports